<template>
  <div v-resize="setContentHeight">
    <div>
      <v-toolbar dark color="primary" classx="px-1">
        <v-btn icon dark @click="goBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>Maps</v-toolbar-title>
      </v-toolbar>

      <v-tabs v-model="mapTabs" fixed-tabs background-color="primary" dark height="40">
        <v-tab class="subtitle-1 font-weight-bold text-capitalize">Seat Plan</v-tab>
        <v-tab class="subtitle-1 font-weight-bold text-capitalize">Floor Plan</v-tab>
      </v-tabs>

      <v-divider />
    </div>

    <div v-if="mapFileNames" ref="viewMapsScrollable" class="scrollable">
      <v-tabs-items id="viewMapMaps" v-model="mapTabs" style="height: inherit">
        <v-tab-item class="flex-center-containerx pa-5" style="height: inherit">
          <v-img :src="`${areaImagePath}${mapFileNames.find(x => x.includes('-sp'))}`" contain :style="imageStyle"></v-img>
        </v-tab-item>

        <v-tab-item class="flex-center-containerx pa-5" style="height: inherit">
          <v-img :src="`${areaImagePath}${mapFileNames.find(x => x.includes('-fp'))}`" contain :style="imageStyle"></v-img>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewMaps",
  props: {
    mapFileNames: Array,
  },
  data: () => ({
    mapTabs: 0,
    contentHeight: 0
  }),
  computed: {
    imageStyle() {
      return this.contentHeight ? { height: (this.contentHeight - 40) + "px" } : null;
    }
  },
  methods: {
    setContentHeight() {
      if (this.$refs.viewMapsScrollable) {
        const heights = this.heights();
        const contentHeight = heights.screen - heights.toolbar - heights.tabbar - heights.noticeBarHeight;
        this.contentHeight = contentHeight;

        this.$refs.viewMapsScrollable.style.height = contentHeight + "px";
      }
    },
  },
  activated() {
    this.$nextTick(() => this.setContentHeight());

    this.mapTabs = 0;
  },
  deactivated() {
    this.mapTabs = 0;
  },
};
</script>
